import { NavLink } from 'react-router-dom';

const BottomBar = () => {
  const navItems = [
    { path: '/', icon: '🏠', label: 'Home' },
    { path: '/todo', icon: '📋', label: 'Todos' },
    { path: '/library', icon: '📚', label: 'Library' },
    { path: '/announcements', icon: '📢', label: 'Announcements' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 lg:hidden">
      <div className="flex justify-around items-center h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-0.5 px-3 py-1 transition ${
                isActive ? 'text-primary' : 'text-gray-500 hover:text-gray-700'
              }`
            }
          >
            <span className="text-2xl">{item.icon}</span>
            <span className="text-xs">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomBar;
